module.exports = __webpack_public_path__ + "img/hc_pro_ten_13.0f97b75e.jpg";